import 'reflect-metadata';
import BaseForm from './BaseForm';

export default abstract class EmbeddedForm<T> extends BaseForm<T> {}
